import type { Weekday } from '../enums';

/**
 * Окна времени для шага «Свободные вечера» (BLUEPRINT 3.2). Подписи — в texts.ts клиентов,
 * здесь только данные. Пользователь выбирает одно окно; оно записывается в `availability.from/to`.
 */
export interface TimeWindowDefinition {
  code: string;
  from: string;
  to: string;
}

export const TIME_WINDOWS: readonly TimeWindowDefinition[] = [
  { code: 'evening', from: '19:00', to: '22:00' },
  { code: 'late', from: '20:00', to: '23:00' },
  { code: 'day', from: '12:00', to: '18:00' },
  { code: 'morning', from: '08:00', to: '12:00' },
];

export const WEEKDAYS: readonly Weekday[] = [1, 2, 3, 4, 5, 6, 7];

/** Окно из списка по границам; null — пользовательское окно. */
export function timeWindowCodeFor(from: string, to: string): string | null {
  return TIME_WINDOWS.find((w) => w.from === from && w.to === to)?.code ?? null;
}
